<template>
	<div class="limitations">
		<div class="limitations__title">Group Accident Expense</div>
		<div class="limitations__form">Forms G H1708/G H1708C</div>
		<p>
			<b><u>Limitations</u></b>
			GROUP ACCIDENT EXPENSE INSURANCE PROVIDES LIMITED BENEFIT COVERAGE.<br />
			This insurance does not provide major medical coverage and does not satisfy the requirement for minimum essential coverage under the Affordable Care Act (ACA).
		</p>
		<p>
			Availability of this product, and its benefits and premiums as presented, is subject to the approval of Assurity. Some applicants with pre-existing conditions may not be eligible for coverage. Product availability, features and rates may vary by state. All benefits, premiums, conditions, exclusions and limitations are governed by the actual contract as provided by Assurity, not this proposal.
		</p>
		<p>
			<b><u>Coverage Conditions</u></b>
			<b>Actively Employed</b> – The employee must be actively employed to be eligible for coverage. <br />
			<b>Right to Cancel</b> – The contract contains a 30-day free look period. <br />
			<b>Termination</b> – Coverage will terminate the earliest of the following: the date policy terminates for any reason; the date employee is no longer an employee; when premiums are not paid by the end of the grace period; the date Assurity receives written notice to terminate; when the employee establishes residence in a foreign country; or upon the employee's death.<br />
		</p>
		<p>
			<b><u>Exclusions</u></b>
			Assurity will not pay benefits under the Policy that are caused by or are the result of the Insured Person(s):
			</p>
			<ul>
				<li>operating, learning to operate, or serving as a crew member of any aircraft;
					<ul>
						<li>(in Idaho) flying professionally with a commercial license for wage or profit;</li>
					</ul>
				</li>
				<li>
					engaging in hang-gliding, hot air ballooning, bungee jumping, parachuting, scuba diving, sail gliding, parasailing, parakiting, mountain or rock climbing, B.A.S.E. jumping, sky diving or cave diving;
					<ul>
						<li>(in Iowa, Idaho, Illinois, New Jersey, Oklahoma, Utah, Virginia, Vermont and Washington) NA</li>
					</ul>
				</li>
				<li>
					riding in or driving any motor-driven vehicle in an organized race, stunt show or speed test;
					<ul>
						<li>(in Iowa, Illinois, New Jersey, Oklahoma, Utah, Virginia, Vermont and Washington) NA</li>
					</ul>		
				</li>
				<li>
					officiating, coaching, practicing for or participating in any semi-professional or professional competitive athletic contest for which any type of compensation or remuneration is received;
					<ul>
						<li>(in California) practicing for or participating in any professional competitive contest for which any type of compensation is received;</li>
						<li>(in Iowa, Illinois, New Jersey, Oklahoma, Utah, Virginia and Vermont) NA</li>
					</ul>
				</li>
				<li>
					having a sickness independent of the Covered Accident, including physical or mental infirmity (sickness means any illness, inflection, disease or any other abnormal physical condition which is not caused by an Injury);
					<ul>
						<li>(in California) NA</li>
					</ul>
				</li>
				<li>
					being exposed to war or any act of war, declared or undeclared;
					<ul>
						<li>(in Maryland and Oklahoma) being exposed to war or any act of war, declared or undeclared while actively serving in any of the armed forces, or units auxiliary thereto, including the National Guard or Army Reserve, except during active duty training of less than 60 days;</li>
						<li>(in North Carolina) being exposed to war or any act of war;</li>
						<li>(in Pennsylvania) sustaining any loss or incurring any expenses while actively serving in any of the armed forces, or units auxiliary thereto, including the National Guard or Army Reserve, except during active duty training of less than 60 days or as a result of being exposed to war or any act of war whether declared or undeclared;</li>
					</ul>
				</li>
				<li>
					actively serving in any of the armed forces, or units auxiliary thereto, including the National Guard or Army Reserve, except during active duty training of less than 60 days;
				</li>
				<li>
					suffering from a Mental and Nervous Disorder (except for Post-Traumatic Stress Disorder as described in the policy/certificate);
					<ul><li>(in Vermont) NA</li></ul>
				</li>
				<li>
					being addicted to drugs or suffering from alcoholism;
					<ul>
						<li>(in California, Maryland, New Jersey, Pennsylvania, South Dakota, Virgina, Vermont and Washington) NA</li>
						<li>(in Connecticut) suffering from alcoholism</li>
						<li>(in Dist. of Columbia) suffering from alcoholism</li>
					</ul>
				</li>
				<li>
					intentionally misusing prescription drugs;
					<ul>
						<li>(in Illinois) having a substance abuse disorder;</li>
						<li>(in Minnesota) being under the influence of any narcotic, unless administered on the advice of a Physician;</li>
					</ul>
				</li>
				<li>
					being under the influence of an excitant, depressant, hallucinogen, narcotic, or any other drug or intoxicant, including those prescribed by a Physician that are misused;
					<ul>
						<li>(in California, Idaho, Maryland, Michigan, Minnesota, Nebraska, New Jersey, Nevada, Oregon, South Dakota, Virginia, Vermont and Washington) NA</li>
						<li>(in Connecticut) voluntary use of any controlled substance as defined in Title II of the Comprehensive Drug Abuse Prevention and Control Act of 1970, as now or hereafter amended, unless as prescribed by Your Physician for the Insured;</li>
						<li>(in Dist. of Columbia) voluntarily using illegal drugs;</li>
						<li>(in Illinois) being under the influence of an excitant, depressant, hallucinogen, narcotic, or any other drug, including those prescribed by a Physician that are misused;</li>
						<li>(in Indiana) being under the influence of an excitant, depressant, hallucinogen, narcotic, or any other drug or intoxicant, except for prescription drugs taken as prescribed;</li>
						<li>(in Kentucky and Texas) being under the influence of an excitant, depressant, hallucinogen, narcotic, or any other drug or intoxicant, unless administered on the advice of a physician;</li>
						<li>(in Louisiana) being under the influence of an excitant, depressant, hallucinogen, narcotic, or intoxicant, including those prescribed by a Physician that are misused;</li>
						<li>(in Oklahoma) being under the influence of an illegal substance or a narcotic (except for narcotics used as prescribed to the Insured Person by a Physician);</li>
						<li>(in Pennsylvania) being under the influence of any intoxicant, unless administered on the advice of a Physician;</li>
					</ul>
				</li>
				<li>
					being intoxicated (as determined by the laws governing the operation of motor vehicles in the jurisdiction where loss occurs) or under the influence of an illegal substance or a narcotic (except for narcotics used as prescribed to the Insured Person by a Physician);
					<ul>
						<li>(in Idaho, Maryland, Michigan, Nevada, Oklahoma, Oregon, Pennsylvania, South Dakota, Vermont and Washington) NA</li>
						<li>(in California) being intoxicated or under the influence of any controlled substance unless administered on the advice of a Physician;</li>
						<li>(in Connecticut) being intoxicated (as determined by the laws governing the operation of motor vehicles in the jurisdiction where loss occurs);</li>
						<li>(in Dist. of Columbia) intentionally taking over the counter medication not in accordance with recommended dosage and warning instructions;</li>
						<li>(in Georgia) being intoxicated or under the influence of any narcotic unless administered on the advice of a Physician;</li>
						<li>(in Minnesota) driving or operating a motor vehicle while intoxicated (as determined by the laws governing the operation of motor vehicles in the jurisdiction where loss occurs);</li>
						<li>(in New Jersey) being intoxicated from or under the influence of any narcotic, unless administered on the advice of a Physician;</li>
						<li>(in Utah) being intoxicated while operating a motor vehicle as determined by the laws in the jurisdiction where loss occurs or under the influence of an illegal substance or a narcotic (except for narcotics used as prescribed to the Insured Person by a Physician);</li>
						<li>(in Virginia) being intoxicated or under the influence of any narcotic, unless taken on the advice of a Physician that are misused;</li>
					</ul>
				</li>
				<li>
					having cosmetic surgery or other elective procedures that are not medically necessary;
					<ul>
						<li>(in California) having cosmetic surgery or other elective procedures;</li>
						<li>(in Idaho) having cosmetic surgery ("cosmetic surgery" shall not include reconstructive surgery when the service is incidental to or follows surgery resulting from trauma, infection or other diseases of the involved part, and reconstructive surgery because of congenital disease or anomaly of a covered dependent child);</li>
					</ul>
				</li>
				<li>
					having a hernia, except as paid under the Hernia Surgery Benefit, if applicable;
					<ul>
						<li>(in Indiana, Oklahoma, Pennsylvania and Utah) NA</li>
						<li>(in Idaho) having elective procedures that are not medically necessary (including but not limited to elective abortion except for preservation of the life of the mother);</li>
						<li>(in Illinois) having an inguinal, ventral, femoral, umbilical, epigastric, hiatal or congenital hernia, except as paid by the Hernia Surgery Benefit;</li>
					</ul>
				</li>
				<li>
					committing or attempting to commit a felony;
					<ul>
						<li>(in Idaho, Maryland and Michigan) NA</li>
						<li>(in Georgia, Illinois and Texas) commission of or attempting to commit a felony;</li>
						<li>(in New Jersey) attempting to commit or commission of a felony;</li>
						<li>(in Utah) voluntarily participating in or attempting to commit a felony;</li>
					</ul>
				</li>
				<li>
					being incarcerated in a penal institution or government detention facility;
					<ul>
						<li>(in California, Iowa, Idaho, Minnesota, Missouri, New Jersey, Ohio, Pennsylvania, Utah, Virginia and Vermont) NA</li>
					</ul>
				</li>
				<li>
					participating in a riot, insurrection or rebellion;
					<ul>
						<li>(in Maryland and Michigan) NA</li>
						<li>(in Connecticut) participating (being involved) in civil disorder or a riot. "Riot" means acting with two or more other persons in a tumultuous and violent manner to intentionally or recklessly cause property damage or physical injury to others;</li>
						<li>(in Utah) voluntarily participating in a riot, insurrection or rebellion;</li>
					</ul>
				</li>
				<li>
					driving any taxi for wage, compensation or profit;
					<ul>
						<li>(in California, Iowa, Illinois, Kentucky, New Jersey, Oklahoma, Pennsylvania, Virginia and Vermont) NA</li>
						<li>(in Idaho) driving professionally for wage, compensation or profit;</li>
					</ul>
				</li>
				<li>
					engaging in an illegal occupation;
					<ul>
						<li>(in Idaho, Illinois, Maryland and Virginia) NA</li>
						<li>(in Connecticut) engaging in a felonious occupation;</li>
						<li>(in Michigan) being engaged in an illegal occupation or other willful criminal activity. "Willful criminal activity" includes, but is not limited to, operating a vehicle while intoxicated as defined in the state in which the accident occurred or operating a methamphetamine laboratory. "Willful criminal activity" does not include a civil infraction or other activity that does not rise to the level of a misdemeanor or felony.</li>
						<li>(in New Jersey) engaging in an illegal activity or occupation;</li>
						<li>(in Utah) voluntarily engaging in an illegal occupation;</li>
					</ul>
				</li>
				<li>
					intentionally self-inflicting an injury;
					<ul>
						<li>(in Michigan, Montana and Minnesota) NA</li>
						<li>(in Colorado) intentionally self-inflicting an injury while sane;</li>
					</ul>
				</li>
				<li>
					committing or attempting to commit suicide, while sane or insane;
					<ul>
						<li>(in Michigan, Montana and Minnesota) NA</li>
						<li>(in California) committing or attempting to commit suicide;</li>
						<li>(in Colorado and Missouri) committing or attempting to commit suicide, while sane;</li>
						<li>(in Pennsylvania and Vermont) committing suicide;</li>
					</ul>
				</li>
				<li>No benefits, except the Initial Accident Treatment benefit, will be payable for services provided outside of the United States.</li>

			</ul>
	</div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.limitations {
	&__title {
		font-weight: bold;
		font-size: 1.2rem;
	}
	b u {
		font-size: 1.1rem;
		display: block;
		margin-bottom: 5px;
	}
	ul {
		margin-bottom: 10px;
	}
}

</style>
